/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type CartNav_financialAmount = {
    readonly amount: number | null;
    readonly currency: Currency | null;
    readonly convertedAmountList: ReadonlyArray<{
        readonly currency: Currency | null;
        readonly amount: number | null;
    } | null> | null;
    readonly " $refType": "CartNav_financialAmount";
};
export type CartNav_financialAmount$data = CartNav_financialAmount;
export type CartNav_financialAmount$key = {
    readonly " $data"?: CartNav_financialAmount$data;
    readonly " $fragmentRefs": FragmentRefs<"CartNav_financialAmount">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "CartNav_financialAmount",
  "type": "FinancialAmount",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "convertedAmountList",
      "storageKey": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v0/*: any*/)
      ]
    }
  ]
};
})();
(node as any).hash = '0acaf8d56c1e760cd755053b99d56c54';
export default node;
